import React, { useState, useEffect } from "react";
import { endPoints } from "../../constant/Environment";
import { getAllData } from "../../Utility/API";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import LinearProgress from "@mui/material/LinearProgress";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

const SurveyResultsModal = ({ survey, onClose }) => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!survey?.id) return;
    setIsLoading(true);
    getAllData(`${endPoints.api.SURVEY_RESULTS}/${survey.id}`)
      .then((res) => setData(res?.status === "success" ? res.data : null))
      .catch((err) => console.error(err))
      .finally(() => setIsLoading(false));
  }, [survey]);

  const options = data?.options || [];
  const total = data?.totalVotes || 0;

  return (
    <Dialog maxWidth="sm" fullWidth open={!!survey} onClose={onClose}>
      <DialogTitle sx={{ pr: 6 }}>
        Survey Results
        <IconButton onClick={onClose} sx={{ position: "absolute", right: 8, top: 8 }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2 }}>
          {data?.question || survey?.question}
        </Typography>

        {isLoading && <Typography variant="body2">Loading…</Typography>}
        {!isLoading && !options.length && <Typography variant="body2">No votes yet.</Typography>}

        {options.map((o) => (
          <Box key={o.index} sx={{ mb: 2 }}>
            <Box sx={{ display: "flex", justifyContent: "space-between", mb: 0.5 }}>
              <Typography variant="body2">{o.text}</Typography>
              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                {o.percent}% ({o.votes})
              </Typography>
            </Box>
            <LinearProgress variant="determinate" value={o.percent || 0} sx={{ height: 8, borderRadius: 4 }} />
          </Box>
        ))}

        {total > 0 && (
          <Typography variant="caption" sx={{ display: "block", textAlign: "right", mt: 2 }}>
            {total} vote{total === 1 ? "" : "s"}
          </Typography>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default SurveyResultsModal;
